import { BASE_API_URL } from '@src/constants'
import { ax } from '@src/utils/axios/axios'

interface LabourCostOptions {
  drsSummaryId: string,
  depotPayroll: string,
}

export const apiDRSLabourCost = ({
  drsSummaryId,
  depotPayroll,
}: LabourCostOptions) => {
  const options = {
    method: 'GET',
    url: `${BASE_API_URL}/labour`,
    params: {
      drsSummaryId,
      depotPayroll,
    },
  }
  return ax(options)
}
